import { motion } from 'motion/react'

import { EmptyState, Text } from '@buffer-mono/popcorn'

import styles from './ActivelyEngaging.module.css'

const EmptyStateIconMotion = motion.create(EmptyState.Icon)

export const ActivelyEngaging = ({
  activeTime,
}: {
  activeTime: string
}): JSX.Element => {
  return (
    <EmptyState
      size="large"
      variant="success"
      role="status"
      aria-label="All comments have been addressed"
      className={styles.wrapper}
    >
      <div className={styles.animationContainer} aria-hidden="true">
        <EmptyStateIconMotion
          className={styles.emptyStateIcon}
          animate={{
            scale: [1, 1.2, 1],
            transition: {
              duration: 1,
            },
            backgroundColor: [
              'var(--color-bg-success-subtle)',
              'var(--global-color-green-300)',
              'var(--color-bg-success-subtle)',
            ],
          }}
        />
        <Text
          className={styles.activelyEngagingTime}
          color="success"
          aria-live="polite"
        >
          {activeTime}
        </Text>
      </div>
      <EmptyState.Heading>
        Well done on being productive and avoiding doom scrolling 👏
      </EmptyState.Heading>
      <EmptyState.Description>
        You&apos;re all caught up! We will let you know when new comments
        appear.
      </EmptyState.Description>
    </EmptyState>
  )
}
